export const getDefaultSuboption = (a: GQL.IAttribute) => {
    if (Array.isArray(a.definition)) {
        const defValue = a.definition.find(d => d.key == 0);

        if (defValue != undefined) {
            return defValue.value;
        }
    }

    return undefined;
};



// WEBPACK FOOTER //
// ./src/helpers/getDefaultSubOption.ts